import { render, staticRenderFns } from "./SelectPharmacyTable.vue?vue&type=template&id=63637ae5&"
import script from "./SelectPharmacyTable.vue?vue&type=script&lang=ts&"
export * from "./SelectPharmacyTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports